/*
  Exclusive PDP accordion: opening one row closes the others.

  The markup already carries a shared `name` on each <details>, which is the
  native HTML exclusive-accordion mechanism. Where the browser supports it,
  nothing here needs to run — so bail out immediately and let the platform do
  it. This file exists only for browsers that predate `name` support.

  `toggle` does not bubble, so the listener is registered in the capture phase.
  Attribute comparison is done by hand rather than with a
  `details[name="..."]` selector, to avoid depending on CSS.escape in exactly
  the older browsers this fallback targets.
*/
(function () {
  if (typeof document === 'undefined') return;
  if ('name' in document.createElement('details')) return;

  document.addEventListener(
    'toggle',
    function (event) {
      var opened = event.target;
      if (!opened || opened.tagName !== 'DETAILS' || !opened.open) return;

      var group = opened.getAttribute('name');
      if (!group) return;

      var all = document.getElementsByTagName('details');
      for (var i = 0; i < all.length; i++) {
        var other = all[i];
        if (other !== opened && other.open && other.getAttribute('name') === group) {
          other.open = false;
        }
      }
    },
    true
  );
})();
